Vue.component('Statement',
    () => import('./components/forms/controls/Statement'/* webpackChunkName: "statement" */)
)

Vue.component('ReportsList',
    () => import('./components/reports/List'/* webpackChunkName: "reports-list" */)
)

Vue.component('ReportViewer',
    () => import('./components/reports/Viewer.vue'/* webpackChunkName: "report-viewer" */)
)

Vue.component('ExportView',
    () => import('./components/money/ExportView.vue'/* webpackChunkName: "export-view" */)
)

Vue.component('VatView',
    () => import('./components/VatView.vue'/* webpackChunkName: "vat-view" */)
)

Vue.component('UserKpis',
    () => import('./components/UserKpis' /* webpackChunkName: "user-kpis" */)
)

Vue.component('BigLeaderboard',
    () => import('./components/summaries/BigLeaderboard' /* webpackChunkName: "big-leaderboard" */)
)

Vue.component('MetricsNavigation',
    () => import('./components/metrics/MetricsNavigation'/* webpackChunkName: "metrics-navigation" */)
)

Vue.component('VehicleReservationList',
    () => import('./components/VehicleReservationList'/* webpackChunkName: "vehicle-reservation-list" */)
)

Vue.component('AccountingSyncQueue',
    () => import('./components/money/AccountingSyncQueue'/* webpackChunkName: "accounting-sync-queue" */)
)

Vue.component('ProfitAndLoss',
    () => import('../ts/Accounts/ProfitAndLoss.vue'/* webpackChunkName: "profit-and-loss" */)
)

Vue.component('LeadList',
    () => import('./components/lead/list/List'/* webpackChunkName: "lead-list" */)
)

Vue.component('JobGroupModal',
    () => import('./components/tasks/GroupModal'/* webpackChunkName: "job-group-modal" */)
)

Vue.component('SignableDocumentViewer',
    () => import('./components/SignableDocumentViewer'/* webpackChunkName: "signable-document-viewer" */)
)

Vue.component('InboxView',
    () => import('./components/inbox/InboxLayout'/* webpackChunkName: "inbox-view" */)
)

Vue.component('ActivitiesView',
    () => import('./components/activity/ActivitiesView'/* webpackChunkName: "activities-view" */)
)

Vue.component('AwaitingPreparationSummary',
    () => import('./components/summaries/AwaitingPreparationSummary'/* webpackChunkName: "awaiting-preparation-summary" */)
)

Vue.component('BookingsSummary',
    () => import('./components/summaries/BookingsSummary'/* webpackChunkName: "bookings-summary" */)
)

Vue.component('LeaderboardSummary', 
    () => import('./components/summaries/LeaderboardSummary'/* webpackChunkName: "leaderboard-summary" */)
)

Vue.component('LeadSummary',
    () => import('./components/summaries/LeadSummary'/* webpackChunkName: "lead-summary" */)
)

Vue.component('PrepTimeSummary',
    () => import('./components/summaries/StockLifecycleKpis.vue'/* webpackChunkName: "prep-time-summary" */)
)

Vue.component('VehiclesOutSummary', 
    () => import('./components/summaries/VehiclesOutSummary'/* webpackChunkName: "vehicles-out-summary" */)
)

Vue.component('DealsOwingSummary', 
    () => import('./components/summaries/DealsOwingSummary'/* webpackChunkName: "deals-owing-summary" */)
)

Vue.component('Metric', 
    () => import('./components/metrics/Metric'/* webpackChunkName: "metric" */)
)

Vue.component('MetricsPanel', 
    () => import('./components/metrics/MetricsPanel'/* webpackChunkName: "metrics-panel" */)
)

Vue.component('MetricsPanelGroup', 
    () => import('./components/metrics/MetricsPanelGroup'/* webpackChunkName: "metrics-panel-group" */)
)

Vue.component('MetricsViewControls', 
    () => import('./components/metrics/MetricsViewControls'/* webpackChunkName: "metrics-view-controls" */)
)

Vue.component('SwitchUserModal', 
    () => import('./components/SwitchUserModal'/* webpackChunkName: "switch-user-modal" */)
)

Vue.component('MoneyReportViewer', 
    () => import('./components/money/reports/ReportViewer'/* webpackChunkName: "money-report-viewer" */)
)

Vue.component('InvoicePayments', 
    () => import('./components/forms/InvoicePayments'/* webpackChunkName: "invoice-payments" */)
)

Vue.component('FrontendStepEditor', 
    () => import('./components/forms/deals/FrontendStepEditor'/* webpackChunkName: "frontend-step-editor" */)
)

Vue.component('ContactFields', 
    () => import('./components/forms/ContactFields'/* webpackChunkName: "contact-fields" */)
)

Vue.component('ShowVehicle', 
    () => import('./components/vehicles/Show'/* webpackChunkName: "show-vehicle" */)
)

Vue.component('ShowVehicleDetail',
    () => import('./components/vehicles/ShowDetail'/* webpackChunkName: "show-vehicle-detail" */)
)

Vue.component('VehiclesList', 
    () => import('./components/vehicles/list/List'/* webpackChunkName: "vehicle-list" */)
)

Vue.component('AiAssistant',
    () => import('../ts/Assistant/AiAssistant'/* webpackChunkName: "ai-assistant" */)
)

Vue.component('StockBookList', 
    () => import('./components/money/stockbook/List'/* webpackChunkName: "stockbook-list" */)
)

Vue.component('AdsList',
    () => import('./components/ads/List'/* webpackChunkName: "ads-list" */)
)

Vue.component('VehicleGrid',
    () => import('./components/vehicles/Grid'/* webpackChunkName: "vehicle-grid" */)
)

Vue.component('ValuationList', 
    () => import('./components/valuations/List'/* webpackChunkName: "valuation-list" */)
)

Vue.component('ShowValuation',
    () => import('./components/valuations/Show'/* webpackChunkName: "show-valuation" */)
)

Vue.component('VehicleLookupForm', 
    () => import('./components/forms/vehicles/VehicleLookupForm'/* webpackChunkName: "vehicle-lookup-form" */)
)

Vue.component('VehicleDefinitionModal', 
    () => import('./components/forms/vehicles/VehicleDefinitionModal'/* webpackChunkName: "vehicle-definition-modal" */)
)

Vue.component('DealsList', 
    () => import('./components/deals/List'/* webpackChunkName: "deals-list" */)
)

Vue.component('ArchivedDealsList',
    () => import('./components/deals/ArchivedList'/* webpackChunkName: "archived-deals-list" */)
)

Vue.component('ShowContact', 
    () => import('./components/contacts/Show'/* webpackChunkName: "show-contact" */)
)

Vue.component('ContactsList', 
    () => import('./components/contacts/List'/* webpackChunkName: "contact-list" */)
)

Vue.component('ExpenseList', 
    () => import('./components/money/ExpenseList'/* webpackChunkName: "expense-list" */)
)

Vue.component('PaymentList',
    () => import('./components/money/PaymentList'/* webpackChunkName: "payment-list" */)
)

Vue.component('ExpenseItemList', 
    () => import('./components/money/ExpenseItemList'/* webpackChunkName: "expense-item-list" */)
)

Vue.component('PartsList', 
    () => import('./components/PartsList'/* webpackChunkName: "parts-list" */)
)

Vue.component('FundingList',
    () => import('./components/finance/funding/List'/* webpackChunkName: "funding-list" */)
)

Vue.component('FinanceList', 
    () => import('./components/finance/FinanceList'/* webpackChunkName: "finance-list" */)
)

Vue.component('SettlementList',
    () => import('./components/finance/settlements/SettlementList'/* webpackChunkName: "settlement-list" */)
)

Vue.component('CommissionList', 
    () => import('./components/money/CommissionList'/* webpackChunkName: "commission-list" */)
)

Vue.component('InvoiceList', 
    () => import('./components/money/invoices/InvoiceList'/* webpackChunkName: "invoice-list" */)
)

Vue.component('InvoiceItemList', 
    () => import('./components/money/invoices/InvoiceItemList'/* webpackChunkName: "invoice-item-list" */)
)

Vue.component('QuoteList', 
    () => import('./components/money/QuoteList'/* webpackChunkName: "quote-list" */)
)

Vue.component('BookingScheduler', 
    () => import('./components/bookings/BookingsScheduler'/* webpackChunkName: "bookings-scheduler" */)
)

Vue.component('BookingsProfitAndLossList',
    () => import('./components/bookings/BookingsProfitAndLossList'/* webpackChunkName: "bookings-profit-and-loss" */)
)


Vue.component('ReservationsScheduler',
    () => import('./components/reservations/ReservationsScheduler'/* webpackChunkName: "reservations-scheduler" */)
)

Vue.component('CommissionView', 
    () => import('./components/CommissionView'/* webpackChunkName: "commission-view" */)
)

Vue.component('UserProfileView', 
    () => import('./components/UserProfileView'/* webpackChunkName: "user-profile-view" */)
)